<template>
  <div class="adminairlineplacement">
    <div class="adminairlineplacement__header">
      <div class="adminairlineplacement__header__left">
        <div class="adminairlineplacement__header__left__search">
          <i class="adx-ic_search"></i>
          <input v-model="searchBoxValue" type="text" placeholder="Search">
        </div>
        <!-- <adx-dropdown-list class="filter" @selected="selectPriceStatus" v-if="priceStatusOptions.length" :valueDisplay="selectedPriceStatus.value" 
          :list="priceStatusOptions" :labelButton="selectedPriceStatus.label?selectedPriceStatus.label:'Future Price Status'" :color="'pink'"/> -->
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset</button>
        </div>
      </div>
      <button class="btn-large primary" @click="addNew">Add New Placement</button>
    </div>
    <div class="adminairlineplacement__listing">
      <div  class="tableWrapper">
      <table>
        <thead>
          <tr>
            <td class="col1">Placement</td>
            <td class="col2">Quantity</td>
            <td class="col2">Bottom Price</td>
            <td class="col2">Public Price</td>
            <td class="col2">Future Price</td>
            <td class="col3"></td>
          </tr>
        </thead>
        <tbody v-if="!isLoading">
          <tr v-for="(placement, index) in placements" :key="index" class="content">
            <td class="col1">
              <div class="placementGroup">
                <div class="subhead placement name">{{placement.name}}</div>
                <div class="small-font detail">{{placement.detail}}</div>
              </div>
            </td>
            <td class="col2"><span class="subhead owner">{{placement.quantity}}</span></td>
            <td class="col2"><span class="subhead owner color-pink">{{placement.bottomPrice | formatMoney}}</span></td>
            <td class="col2"><span class="subhead owner color-pink">{{placement.publicPrice | formatMoney}}</span></td>
            <td v-if="placement.futureprices.length === 0" class="col2"><span>-</span></td>
            <td v-else-if="placement.futureprices.length > 0 && placement.futureprices.length <=1" class="col2">
              <div v-for="(price, index) in placement.futureprices" :key="index" class="subhead elipsis">
                <span class="color-grey mini-font">Start on:</span><br/>
                {{price.period}}
                <label-status class="dropdownDoc__item label" :progress="price.status"/>
              </div>
            </td>
            <td v-else-if="placement.futureprices.length > 1" class="col2">
              <div :class="[show[index] ? '': 'hidden']">
                <div v-for="(price, index) in placement.futureprices" :key="index" class="subhead elipsis">
                  <span class="color-grey mini-font">Start on:</span><br/>
                  <span class="subhead">{{price.period}}</span>
                  <label-status class="dropdownDoc__item label" :progress="price.status"/>
                </div>
              </div>
              <div v-if="!show[index]" class="showButton">
                <span class="small-font toggleShow" @click="showMore(index)">Show More</span>
                <i class="icon-chevrondown"></i>
              </div>
              <div v-else class="showButton">
                <span class="small-font toggleShow" @click="showMore(index)">Show Less</span>
                <i class="icon-chevronup"></i>
              </div>
            </td>
            <td class="col3">
              <menu-expansion :lists="menuActions" @selected="selectedMenu($event, placement)"/>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !isLoading" :title="title"/>
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <adx-loading/>
      </div>
      <div class="pagination" v-if="!isLoading && !isEmpty">
        <div class="total" >{{getDataRange}} of {{count}} placements</div>
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
      </div>
    </div>
    <adx-modal hideClose="true" v-if="isShowModal" title="Delete Placement" type="small">
      <div slot="content" class="adminairlineplacement__modal">
        <div class="adminairlineplacement__modal__top">
          <span>Sure want to delete this placement?</span>
        </div>
        <div class="adminairlineplacement__modal__bottom">
          <button class="btn-regular primary" @click="deletePlacement()">Yes<adx-loading-2 class="btn-loading" v-if="isLoadingMutation"/></button>
          <button class="btn-regular secondary" @click="cancelDelete()">Cancel</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import api from '@/api'
import lib from '@/lib/util'
import moment from 'moment'
import { ASelectDropdown, AEmptySelection, ALoadingPrimary, ALoadingSecondaryWhite, APagination, 
        AMenuExpansion, AStatusLabel, AListDropdown, AModal} from "ui-kit-v1"

import { mapGetters } from 'vuex'
import { restEdge } from '@/api/edgeUrls'
import { globalMixins } from "@/lib/mixins/globalMixins";

import * as validationLib from "@/lib/validation/"
const { helpers, validate } = validationLib;

export default {
  name: 'adx-bus-placement',
  components: {
    'adx-modal': AModal,
    'adx-empty-selection': AEmptySelection,
    'adx-loading': ALoadingPrimary,
    'adx-loading-2': ALoadingSecondaryWhite,
    'adx-pagination': APagination,
    'menu-expansion': AMenuExpansion,
    'adx-select-dropdown': ASelectDropdown,
    'adx-dropdown-list': AListDropdown,
    'label-status': AStatusLabel,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      category: null,
      count: 0,
      maxPage: 1,
      isEmpty: false,
      isLoadingMain:false,
      isLoadingMutation: false,
      isShowModal: false,
      searchBoxValue: null,
      selectedPlacementId: null,
      selectedPage: 1,
      selectedPriceStatus: {
        value: null,
        label: null
      },
      selectedSortValue: "last_added",
      show: [],
      title: "You dont have any Placement here. lets create some !",
      priceStatusOptions: [
        {
          id: 1,
          label: "Upcoming",
          value: "upcoming",
        },
        {
          id: 2,
          label: "Active",
          value: "active",
        },
        {
          id: 3,
          label: "Expired",
          value: "expired",
        }
      ],
      menuActions: [
        {
          'id': 1,
          'name': ' Edit Placement',
          'value': 'editplacement',
        },
        {
          'id': 2,
          'name': 'Duplicate Placement',
          'value': 'duplicateplacement'
        },
        {
          'id': 3,
          'name': 'Delete Placement',
          'value': 'deleteplacement'
        }
      ],
      placements: []
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isLoading: function(){
      return this.isLoadingMain || this.isLoadingMutation || false
    },
    getDataRange: function(){
      let endPage = this.selectedPage * 15;
      return this.count > 15 ? ((endPage < this.count) ? endPage: endPage - 15 + (this.count % 15)) : this.count
    },
    filtered: function() {
      let filtered = false
      if (this.selectedPriceStatus.label){
        filtered = true
      }
      return filtered
    },
    getQueryParams(){
      let queryParams = {
        search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
        futurePriceStatus: this.selectedPriceStatus.value != null ? this.selectedPriceStatus.value.toString() : undefined,
      }
      return queryParams
    }
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getPlacement()
    }, 500),
    selectedSortValue: function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getPlacement()
    },
    selectedPage: function (){
      this.count = 0;
      this.getPlacement()
    },
    selectedPriceStatus: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedPriceStatus = newValue;
        this.count = 0;
        this.getPlacement()
      }
    },
  },
  beforeCreate() {

  },
  created() {
    this.getPlacement();
    this.createShowArray()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getPlacement(){
      this.isLoadingMain = true;
      const response = await api.get(restEdge.adminAirlinePlacement, { needToken: true, useRestEdge: true, params:{page:this.selectedPage, ...this.getQueryParams, sort: this.selectedSortValue}});
      
      if(response.status == 200){
        const {data} = response
        let tmpplacements = []
        data.results.map( placement => {
          let futurePrices = placement.airlinesFuturePrice.map((price) => {
            return {
                period: this.displayPeriod(price.start, price.end),
                status: this.displayStatus(price.status),
              }
            }  
          )
          tmpplacements.push({
            id: placement.id,
            name: placement.name,
            detail: placement.airlinesMedia? placement.airlinesMedia.name : '-',
            futureprices: futurePrices,
            quantity: placement.quantity,
            publicPrice: placement.publicPrice,
            bottomPrice: placement.bottomPrice,
            delete: true
          })
        });
        this.placements = await tmpplacements;
        this.maxPage = data.maxPage;
        this.count = data.count
        this.isEmpty = this.placements.length === 0;
        this.isLoadingMain = false;
      } else {
        this.showNotificationAlert("Error", "Data failed to load!", "danger");
        this.isLoadingMain = false;
        this.isEmpty = true
        console.log(`error`)
      }
    },
    addNew() {
      this.$router.push({name: 'addplacementairline'})
    },
    selectedMenu(index, item){
      if(index.value ===  'editplacement'){
        this.$router.push({name: 'editplacementairline',  params: {  id: item.id }})
      } else if(index.value ===  'duplicateplacement'){
        this.duplicatePlacement(item.id)
      } else if(index.value ===  'deleteplacement'){
        this.confirmDelete(item.id)
      }
    },
    selectPriceStatus(item){
      this.selectedPriceStatus = item
    },
    resetFilter(){
      let price = { id:0, label: null, value: null }
      this.selectedPriceStatus = price
      this.getPlacement()
    },
    async deletePlacement() {
      this.isLoadingMutation = true;
      
      const response = await api.destroy(restEdge.adminAirlinePlacementDelete(this.selectedPlacementId), { needToken: true, useRestEdge: true });
      if(response.status == 200) {
        this.toggleModal();
        this.getPlacement();
        this.isLoadingMutation = false;
        this.showNotificationAlert("Success", "Data successfully deleted!", "success");
      } else {
        this.toggleModal();
        this.getPlacement();
        this.isLoadingMutation = false;
        this.showNotificationAlert("Error", "Data failed to delete!", "danger");
      }
    },
    confirmDelete(id){
      this.selectedPlacementId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedPlacementId = null;
      this.toggleModal()
    },
     async duplicatePlacement(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.adminAirlinePlacementDuplicate(id), {}, { needToken: true, useRestEdge: true,});

      if (response.status == 200) {
        this.getPlacement();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully duplicated!', 'success')
      } else {
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to duplicate!', 'danger')
      }
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      this.getPlacement()
    },
    processedDetail(array, category) {
      let processed = [];
      if (array){
        array.map(index => {
          processed.push(index.location)
        })
      }
      let processed_mid=[];
      if (processed.length > 3){
        let len = Math.round(processed.length/2);
        processed_mid.push(processed[len-1]);
        processed_mid.push(processed[len]);
        processed_mid.push(processed[len+1])
      } else {
        processed_mid = processed
      }
      let final_process = processed_mid.join(' - ');
      let cat = category? category.title : "";
      return '('+ cat+ ') Via ' + final_process
    },
    processedPlacement(bus) {
      let processed = [];
      if (bus){
        bus.map(index => {
          processed.push(index.generic.title)
        })
      }
      return processed
    },
    createShowArray() {
      let i = 0;
      for (i = 0; i < this.placements.length; i++) {
        this.show.push(false)
      }
    },
    displayPeriod(start, end) {
      let startDate = 'Unset'
      let endDate = 'Unset'
      if (start) {
        startDate = `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(start))}`
      } 
      if (end) {
        endDate = `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(end))}`
      }
      return startDate + ` - ` + endDate
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>